import React, {PropTypes} from 'react';
import {FormattedDate} from 'react-intl';

class EventItem extends React.PureComponent{
 static propTypes = {
    description: PropTypes.string,
    image: PropTypes.string,
    list: PropTypes.string,
    loading: PropTypes.func,
    name: PropTypes.string,
    start: PropTypes.string
  };

  handleLoading() {
    this.props.loading();
  }

  render() {
    return(
      <div>
        <img src={this.props.image} alt={this.props.name} className="item-thumbnail"
             onLoad={this.handleLoading.bind(this)} onError={this.handleLoading.bind(this)} />
        <div className="item-info">
          <h5 className="item-title">{this.props.name}</h5>
          <h6 className="start-date price">
            {
              // Only print the Intl object after receiving the updated props
              this.props.start.length > 0
                ? <FormattedDate value={new Date(this.props.start)}
                                 year="numeric" month="numeric" day="numeric" weekday="long"/>
                : ''
            }
          </h6>

          {this.props.list === 'true' ?
            null
            : <p>{this.props.description}</p>
          }
        </div>
      </div>
    );
  }
}

export default EventItem;



/** WEBPACK FOOTER **
 ** ./src/components/restaurant/EventItem.js
 **/